import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'apm-table-input-type',
  templateUrl: './table-input-type.component.html',
  styleUrls: ['./table-input-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableInputTypeComponent extends FieldType<FieldTypeConfig> {
  @Input() className = '';

  ignoredKeyCodes = ['KeyE'];

  onKeyDown(e: KeyboardEvent) {
    if (this.ignoredKeyCodes.includes(e.code)) {
      e.preventDefault();
    }
  }
}
